"use client";

import * as React from "react";
export default function SignUpForm() {
  const [isLoading, setIsLoading] = React.useState(true);
  React.useEffect(() => {
    try {
      const d = document.getElementById("zf_div_zN4FssymlYH9UwvyLrSOtnO3MhqfJWzaGRJ_D77pepc");
      if (!d) return;
      while (d.firstChild) {
        d.removeChild(d.firstChild);
      }
      const f = document.createElement("iframe");
      let ifrmSrc = 'https://forms.zohopublic.ca/infocolumbiav1/form/ClientDetails/formperma/zN4FssymlYH9UwvyLrSOtnO3MhqfJWzaGRJ_D77pepc?zf_rszfm=1';
      try {
        if (typeof (window as any).ZFAdvLead != "undefined" && typeof (window as any).zfutm_zfAdvLead != "undefined") {
          for (let prmIdx = 0; prmIdx < (window as any).ZFAdvLead.utmPNameArr.length; prmIdx++) {
            let utmPm = (window as any).ZFAdvLead.utmPNameArr[prmIdx];
            utmPm = (window as any).ZFAdvLead.isSameDomian && (window as any).ZFAdvLead.utmcustPNameArr.indexOf(utmPm) == -1 ? "zf_" + utmPm : utmPm;
            const utmVal = (window as any).zfutm_zfAdvLead.zfautm_gC_enc((window as any).ZFAdvLead.utmPNameArr[prmIdx]);
            if (typeof utmVal !== "undefined") {
              if (utmVal != "") {
                if (ifrmSrc.indexOf('?') > 0) {
                  ifrmSrc = ifrmSrc + '&' + utmPm + '=' + utmVal;
                } else {
                  ifrmSrc = ifrmSrc + '?' + utmPm + '=' + utmVal;
                }
              }
            }
          }
        }
        if (typeof (window as any).ZFLead !== "undefined" && typeof (window as any).zfutm_zfLead !== "undefined") {
          for (let prmIdx = 0; prmIdx < (window as any).ZFLead.utmPNameArr.length; prmIdx++) {
            const utmPm = (window as any).ZFLead.utmPNameArr[prmIdx];
            const utmVal = (window as any).zfutm_zfLead.zfutm_gC_enc((window as any).ZFLead.utmPNameArr[prmIdx]);
            if (typeof utmVal !== "undefined") {
              if (utmVal != "") {
                if (ifrmSrc.indexOf('?') > 0) {
                  ifrmSrc = ifrmSrc + '&' + utmPm + '=' + utmVal;
                } else {
                  ifrmSrc = ifrmSrc + '?' + utmPm + '=' + utmVal;
                }
              }
            }
          }
        }
      } catch (e) {
        console.error('UTM parameter error:', e);
      }
      f.src = ifrmSrc;
      f.style.border = "none";
      f.style.height = "1582px";
      f.style.width = "100%";
      f.style.transition = "all 0.5s ease";
      f.setAttribute("aria-label", 'Sign Up for Service');
      f.onload = () => {
        setIsLoading(false);
      };
      d.appendChild(f);
      const handleMessage = (event: MessageEvent) => {
        const evntData = event.data;
        if (evntData && evntData.constructor == String) {
          const zf_ifrm_data = evntData.split("|");
          if (zf_ifrm_data.length == 2 || zf_ifrm_data.length == 3) {
            const zf_perma = zf_ifrm_data[0];
            const zf_ifrm_ht_nw = parseInt(zf_ifrm_data[1], 10) + 15 + "px";
            const iframe = document.getElementById("zf_div_zN4FssymlYH9UwvyLrSOtnO3MhqfJWzaGRJ_D77pepc")?.getElementsByTagName("iframe")[0];
            if (iframe && iframe.src.indexOf('formperma') > 0 && iframe.src.indexOf(zf_perma) > 0) {
              const prevIframeHeight = iframe.style.height;
              let zf_tout = false;
              if (zf_ifrm_data.length == 3) {
                iframe.scrollIntoView();
                zf_tout = true;
              }
              if (prevIframeHeight != zf_ifrm_ht_nw) {
                if (zf_tout) {
                  setTimeout(function () {
                    iframe.style.height = zf_ifrm_ht_nw;
                  }, 500);
                } else {
                  iframe.style.height = zf_ifrm_ht_nw;
                }
              }
            }
          }
        }
      };
      window.addEventListener('message', handleMessage, false);
      return () => {
        window.removeEventListener('message', handleMessage, false);
      };
    } catch (e) {
      console.error('Zoho form initialization error:', e);
      setIsLoading(false);
    }
  }, []);
  return <section className="relative bg-gradient-to-br from-primary/5 via-background to-secondary/5 py-8 sm:py-10 lg:py-12 overflow-hidden">
      {}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-primary/30 rounded-full blur-3xl"></div>
        
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        {}
        <div className="text-center mb-12 animate-fade-up">
          <h1 className="text-4xl md:text-5xl font-bold text-foreground mb-4 leading-snug">Book Your Service</h1>
          <p className="text-lg md:text-xl text-foreground/70 leading-relaxed max-w-2xl mx-auto">Sign up online and we will call you to confirm your appintment.&nbsp;</p>
        </div>

        {}
        <div className="bg-surface rounded-md shadow-soft p-6 sm:p-8 lg:p-10 animate-fade-up-delay-100 transition-all duration-[var(--duration-medium)]">
          <div className="flex flex-col items-center justify-center">
            {isLoading && <div className="w-full flex items-center justify-center py-12" role="status" aria-live="polite">
                <div className="flex flex-col items-center gap-4">
                  <div className="w-12 h-12 border-4 border-primary/20 border-t-primary rounded-full animate-spin"></div>
                  <p className="text-sm text-foreground/60">Loading sign-up form...</p>
                </div>
              </div>}
            <div id="zf_div_zN4FssymlYH9UwvyLrSOtnO3MhqfJWzaGRJ_D77pepc" className={`w-full max-w-4xl mx-auto flex justify-center transition-opacity duration-500 ${isLoading ? 'opacity-0' : 'opacity-100'}`}></div>
          </div>
        </div>

        {}
        <div className="text-center mt-8 animate-fade-up-delay-200">
          <p className="text-sm text-foreground/60 leading-relaxed">Have questions? <span className="text-primary font-medium" data-ast-id="f:/src/pages/BookNow/sections/SignUpForm.tsx|sig:21156y" data-ast-start="6157" data-ast-end="6217">Contact us</span> and we'll be happy to help you.&nbsp;</p>
        </div>
      </div>
    </section>;
}